import React from "react";
import i18next from "i18next";

import {authRoles} from "../../auth/index.js";
import en from "./i18n/en.js";

i18next.addResourceBundle("en", "home", en);

const HomeConfig = {
  settings: {layout: {config: {}}},
  auth: authRoles.user,
  routes: [
    {
      path: "/",
      exact: true,
      component: React.lazy(() => import("./home.js")),
    },
  ],
};

export default HomeConfig;
